export default function ContentDisplay({ slide }) {
  return (
    <div className="flex flex-col items-center justify-center text-center px-8 py-12 max-w-4xl">
      {slide?.title && (
        <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6">
          {slide.title}
        </h1>
      )}
      {slide?.description && (
        <p className="text-xl md:text-2xl text-blue-200 leading-relaxed max-w-3xl">
          {slide.description}
        </p>
      )}
      {!slide?.title && !slide?.description && (
        <p className="text-blue-400 text-xl">Tomt innhaldsslide</p>
      )}
    </div>
  );
}
